import { SearchProduct } from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import { create } from 'zustand';

type FeaturedProduct = {
  product: SearchProduct;
  quantity: number;
};

export interface FeaturedProductsProps {
  products: FeaturedProduct[];
}

export interface FeaturedProductsState extends FeaturedProductsProps {
  setFeaturedProducts: (products: FeaturedProduct[]) => void;
  removeFeaturedProducts: () => void;
}

export const initialState: FeaturedProductsProps = {
  products: [],
};

export const useFeaturedProducts = create<FeaturedProductsState>(
  (set, get) => ({
    ...initialState,
    setFeaturedProducts: (products) => {
      set({ products });
    },
    removeFeaturedProducts: () => {
      set({ products: [] });
    },
  }),
);
